import { LOGISTICS_DATAS } from "../../constants";
import { formatDeliveryAddress } from "../../helpers";

//* ທີ່ຢູ່ປາຍທາງ ສຳລັບພິມບິນ — ໃຊ້ຮ່ວມກັນທຸກແບບບິນ
//*   1. ມີ orderDelivery (ລູກຄ້າເລືອກຂົນສົ່ງ / ຈອງແລ້ວ) → "ສາຂາ, ເມືອງ, ແຂວງ" ຈາກ receiver
//*   2. ບໍ່ມີ → addressCf (ທີ່ຢູ່ທີ່ພິມ ຫຼື ເລືອກໃນໜ້າສ້າງອໍເດີ) → destinationLogistic
export const billDestination = (item) => {
  const fromDelivery = item?.orderDelivery?.id
    ? formatDeliveryAddress(item?.orderDelivery?.receiver)
    : "";
  return fromDelivery || item?.addressCf || item?.destinationLogistic || "";
};

//* ຊື່ຂົນສົ່ງ ສຳລັບພິມບິນ — ຈາກ orderDelivery ກ່ອນ, ບໍ່ມີ → ຊື່ທີ່ບັນທຶກໃນອໍເດີ (logistic)
//*   "ພິມທີ່ຢູ່ເອງ" ບໍ່ແມ່ນຊື່ຂົນສົ່ງ → ບໍ່ສະແດງ
export const billLogistic = (item) => {
  const key = item?.orderDelivery?.delivery;
  const fromDelivery = key ? LOGISTICS_DATAS?.[String(key).toLowerCase()]?.name || key : "";
  const name = fromDelivery || item?.logistic || "";
  return name === "ພິມທີ່ຢູ່ເອງ" || name === item?.addressCf ? "" : name;
};

//* ແຖວ "ທີ່ຢູ່" ຂອງຜູ້ຮັບ ໃນບິນຂົນສົ່ງ (ມີແຖວ "ສາຂາ" ແຍກຢູ່ແລ້ວ) → ບ້ານ, ເມືອງ, ແຂວງ ບໍ່ຊ້ຳສາຂາ
//*   ບໍ່ມີ orderDelivery → ໃຊ້ທີ່ຢູ່ໃນອໍເດີ (addressCf)
export const billReceiverAddress = (item) => {
  const r = item?.orderDelivery?.id ? item?.orderDelivery?.receiver : null;
  const fromDelivery = r ? [r.village, r.district, r.province].filter(Boolean).join(", ") : "";
  return fromDelivery || item?.addressCf || item?.destinationLogistic || "";
};

//* ສາຂາປາຍທາງ ສຳລັບພິມບິນ
//*   1. ມີ orderDelivery → receiver.branch
//*   2. ບໍ່ມີ (ອໍເດີທີ່ຮ້ານສ້າງເອງ) → ສ່ວນ "ສາຂາ" ຂອງ addressCf ທີ່ບັນທຶກເປັນ "ສາຂາ, ເມືອງ, ແຂວງ"
//*      (ຮູບແບບດຽວກັບ DestinationPicker) — ສັ້ນກວ່າ 3 ສ່ວນ = ບໍ່ຮູ້ວ່າສ່ວນໃດເປັນສາຂາ → ວ່າງ
export const billReceiverBranch = (item) => {
  const fromDelivery = item?.orderDelivery?.receiver?.branch;
  if (fromDelivery) return fromDelivery;
  const parts = String(item?.addressCf || item?.destinationLogistic || "")
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
  return parts.length >= 3 ? parts.slice(0, -2).join(", ") : "";
};

//* ສາຂາຕົ້ນທາງ ສຳລັບພິມບິນ — ຂອງຮ້ານສະເໝີ ໃຫ້ກົງກັບແຖວ "ທີ່ຢູ່" ຂອງຜູ້ຝາກ (billSenderAddress)
//*   1. ມີ orderDelivery → sender.branch
//*   2. ບໍ່ມີ (ອໍເດີທີ່ຮ້ານສ້າງເອງ) → ບ້ານ ໃນທີ່ຢູ່ຮ້ານ (shopData.address)
export const billSenderBranch = (item, shopData) =>
  item?.orderDelivery?.sender?.branch || shopData?.address?.village || "";

//* ຜູ້ຮັບ ສຳລັບພິມບິນ — ບໍ່ມີ orderDelivery → ຂໍ້ມູນລູກຄ້າໃນອໍເດີ (ບໍ່ແມ່ນຂອງຮ້ານ)
export const billReceiverName = (item) =>
  item?.orderDelivery?.receiver?.fullName || item?.customerName || item?.cfName || "";
export const billReceiverTel = (item) =>
  item?.orderDelivery?.receiver?.tel || item?.phone || "";

//* ການເກັບເງິນ ສຳລັບພິມບິນ: FREE = ເກັບຄ່າຂົນສົ່ງຕົ້ນທາງ, CDC = ເກັບຄ່າຂົນສົ່ງປາຍທາງ, COD = ຄ່າຂົນສົ່ງ ແລະ ຄ່າເຄື່ອງປາຍທາງ
//*   1. ມີ orderDelivery → shipmentPayType ທີ່ຈອງໄວ້
//*   2. ບໍ່ມີ → ຈາກອໍເດີ (paymentType/paymentPlan/payment) ແບບດຽວກັບໜ້າສ້າງອໍເດີ (OrderAddV2)
export const billShipmentPayType = (item) => {
  if (item?.orderDelivery?.shipmentPayType) return item.orderDelivery.shipmentPayType;
  if (item?.paymentPlan === "COD" || item?.payment === "COD") return "COD";
  return item?.paymentType === "ORIGINAL" ? "FREE" : "CDC";
};

export const BILL_SHIPMENT_PAY_TYPE_LABEL = {
  FREE: "ເກັບເງິນຕົ້ນທາງ",
  CDC: "ເກັບເງິນປາຍທາງ",
  COD: "ເກັບຄ່າຂົນສົ່ງ ແລະ ຄ່າເຄື່ອງປາຍທາງ",
};

//* ລະຫັດ COD ທີ່ຮ້ານໃສ່ໃນອໍເດີ — ສະແດງສະເພາະຕອນເກັບປາຍທາງ (CDC/COD)
export const billCodNumber = (item) =>
  billShipmentPayType(item) === "FREE" ? "" : String(item?.codNumber || "").trim();

//* shipments ເປັນ JSON string ຈາກຂົນສົ່ງ — ອໍເດີທີ່ບໍ່ມີ orderDelivery ຈະບໍ່ມີ → ຢ່າໃຫ້ບິນພັງ
export const billShipments = (item) => {
  try {
    return JSON.parse(item?.orderDelivery?.shipments || "null") || {};
  } catch (e) {
    return {};
  }
};

//* ທີ່ຢູ່ຕົ້ນທາງ (ຜູ້ສົ່ງ) ສຳລັບພິມບິນ — ບ້ານ, ເມືອງ, ແຂວງ
//*   1. ມີ orderDelivery → ທີ່ຢູ່ຜູ້ສົ່ງທີ່ໃຊ້ຈອງຂົນສົ່ງ (sender)
//*   2. ບໍ່ມີ → ທີ່ຢູ່ຂອງຮ້ານ (shopData.address ຈາກ query SHOP)
export const billSenderAddress = (item, shopData) => {
  const join = (a) => [a?.village, a?.district, a?.province].filter(Boolean).join(", ");
  const fromDelivery = item?.orderDelivery?.id ? join(item?.orderDelivery?.sender) : "";
  return fromDelivery || join(shopData?.address) || "";
};
